import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';

const QuestionTableCell = withStyles((theme) => ({
  body: {
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.common.white,
    fontSize: '0.9rem',
    fontWeight: 500,
  },
}))(TableCell);

const AnswerTableCell = withStyles((theme) => ({
  body: {
    backgroundColor: theme.palette.common.white,
    fontSize: '0.9rem',
  },
}))(TableCell);

const useStyles = makeStyles(theme => ({
  root: {
    padding: '1rem',
    maxWidth: '45rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  header: {
    marginBottom: '1.5rem',
  },
  text: {
    padding: '0.5rem 0',
    textAlign: 'center',
    marginBottom: '1.5rem',
  },
  table: {
    border: `1px solid ${theme.palette.common.silver}`,
  },
}));

const RequestFinalise = ({data}) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="h2" color="primary" className={classes.header}>
        Almost done!
      </Typography>
      <Typography variant="h3" className={classes.text}>
        Here is a summary of your information. Please double check and click Finish to submit your request.
      </Typography>
      <TableContainer>
        <Table className={classes.table}>
          <TableBody>
            <TableRow>
              <QuestionTableCell>The request is for:</QuestionTableCell>
              <AnswerTableCell>{data.participant_type}</AnswerTableCell>
            </TableRow>
            <TableRow>
              <QuestionTableCell>The following services are required:</QuestionTableCell>
              <AnswerTableCell>
                {data.services.map((item, i) => (
                  <Typography variant="body2" key={i}>
                    {item.name}{item.amount === 'NA' ? null : `, ${item.amount}`}
                  </Typography>
                ))}
              </AnswerTableCell>
            </TableRow>
            <TableRow>
              <QuestionTableCell>The services are required at:</QuestionTableCell>
              <AnswerTableCell>{data.location}</AnswerTableCell>
            </TableRow>
            <TableRow>
              <QuestionTableCell>The recipient&apos;s NDIS plan is:</QuestionTableCell>
              <AnswerTableCell>{data.management_type}</AnswerTableCell>
            </TableRow>
            <TableRow>
              <QuestionTableCell>The recipient&apos;s age group is:</QuestionTableCell>
              <AnswerTableCell>{data.age_group}</AnswerTableCell>
            </TableRow>
            <TableRow>
              <QuestionTableCell>Your contact details are:</QuestionTableCell>
              <AnswerTableCell>Email: {data.contact.email}<br/>Phone: {data.contact.phone}</AnswerTableCell>
            </TableRow>
            <TableRow>
              <QuestionTableCell>The following considerations apply:</QuestionTableCell>
              <AnswerTableCell>
                {data.considerations.map((item, idx) => (
                  <Typography variant="body2" key={idx}>
                    {item}
                  </Typography>
                ))}
              </AnswerTableCell>
            </TableRow>
            {data.other !== '' ? (
              <TableRow>
                <QuestionTableCell>Other important information is:</QuestionTableCell>
                <AnswerTableCell>{data.other}</AnswerTableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

RequestFinalise.propTypes = {
  data: PropTypes.object.isRequired,
};

export default RequestFinalise;
